"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.colors = exports.cubehelix = void 0;
const chroma_js_1 = __importDefault(require("chroma-js"));
const allCubehelix = chroma_js_1.default
    .cubehelix()
    .start(201)
    .rotations(-0.42)
    .hue([1.57, 1.48])
    .gamma(0.9)
    .lightness([0.58, 0.82])
    .scale()
    .colors(10);
exports.cubehelix = allCubehelix;
exports.colors = {
    orange: {
        bright: 'rgb(231, 126, 40)',
        dark: 'rgb(219, 124, 44)',
        carrot: 'rgb(243, 120, 73)',
        carrotWithOpacity: 'rgba(243, 120, 73, 0.6)',
        peach: 'rgb(243, 169, 107)',
        almond: 'rgb(255, 233, 221)' // #FFE9DD
    },
    red: {
        rose: 'rgb(144, 0, 0)',
        brick: 'rgb(191, 87, 87)',
        indian: 'rgb(224, 123, 123)',
        lemonade: 'rgb(255, 223, 223)',
        ochra: 'rgb(247, 179, 47)',
        canary: 'rgb(255, 214, 134)' // #FFD686
    },
    green: {
        spruce: 'rgb(7, 109, 45)',
        moss: 'rgb(57, 193, 108)',
        seafoam: 'rgb(138, 221, 169)',
        sheenGreen: 'rgb(166, 201, 106)' // #a6c96a
    },
    black: {
        oil: 'rgb(34, 34, 34)',
        obsidian: 'rgb(40, 40, 40)',
        jet: 'rgb(44, 44, 44)',
        onyx: 'rgb(51, 51, 51)',
        ebony: 'rgb(60, 60, 60)',
        monument: 'rgb(68, 68, 68)',
        granite: 'rgb(76, 76, 76)',
        charcoal: 'rgb(92, 92, 92)',
        tangaroa: 'rgb(13, 35, 58),' // #0d233a
    },
    grey: {
        steel: 'rgb(119, 119, 119)',
        chrome: 'rgb(153, 153, 153)',
        smoke: 'rgb(170, 170, 170)',
        cloud: 'rgb(210, 210, 210)',
        platinum: 'rgb(238, 238, 238)',
        joku: 'rgb(242, 242, 242)',
        silver: 'rgb(249, 249, 249)',
        snow: 'rgb(255, 255, 255)' // #FFF
    },
    blue: {
        danube: 'rgb(97, 169, 208)',
        danubeWithOpacity: 'rgba(97, 169, 208, 0.6)',
        ultramarine: 'rgb(48, 146, 201)',
        azure: 'rgb(90, 176, 255)',
        light: 'rgb(106,183,226)',
        lighter: 'rgb(171, 215, 255)',
        dark: 'rgb(64, 149, 204)',
        mariner: 'rgb(47, 126, 216)',
        pacificBlue: 'rgb(26, 173, 206)',
        cobalt: 'rgb(30, 72, 143)',
        clear: 'rgb(1, 184, 249)',
        clearTransparent: 'rgba(204, 242, 255, 0.5)'
    },
    purple: {
        windsor: 'rgb(67, 41, 112)',
        pink: 'rgb(239, 188, 239)' // #EFBCEF
    }
};
